<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">utilities</p>
        <h1 class="dg-header">Spacing</h1>
        <p>Shorthand responsive margin and padding utility classes to modify an element’s appearance.</p>
      </div>
    </div>

    <div class="row content">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <!-- Content -->
        <div class="row">
          <div class="col">
            <p class="h3 dg-subheader">How it works</p>
            <p>Assign responsive-friendly <span class="code">margin</span> or <span class="code">padding</span> values to an element or a subset of its sides with shorthand classes. Includes support for individual properties, all properties, and vertical and horizontal properties. Classes are built from a default Sass map ranging from <span class="code">.25rem</span> to <span class="code">3rem</span>.</p>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            
            <div class="row">
              <div class="col">
                <p class="h3 dg-subheader">Variants / Modifiers</p>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col">
                <p>To have spacing utilities inherit on all breakpoints, simply do not add a breakpoint abbreviation to them. If you wish to have spacing utilities on specific breakpoints, use <span class="code">sm</span>, <span class="code">md</span>, <span class="code">lg</span>, and <span class="code">xl</span>. Remember, every breakpoint above the one you specify will inherit the spacing, so be sure to keep that in mind (e.g. if added on <span class="code">sm</span>, will also add spacing on <span class="code">md</span>, <span class="code">lg</span> and <span class="code">xl</span>).</p>
                <!-- <p>Spacing utilities that apply to all breakpoints, from <span class="code">xs</span> to <span class="code">xl</span>, have no breakpoint abbreviation in them. This is because those classes are applied from <span class="code">min-width: 0</span> and up, and thus are not bound by a media query. The remaining breakpoints, however, do include a breakpoint abbreviation.</p> -->
                <p>The classes are named using the format <span class="code">{property}{sides}-{size}</span> for <span class="code">xs</span> and <span class="code">{property}{sides}-{breakpoint}-{size}</span> for <span class="code">sm</span>, <span class="code">md</span>, <span class="code">lg</span>, and <span class="code">xl</span>.</p>
                <p>Where <span class="font-weight-bold">property</span> is one of:</p>
                <ul>
                  <li><span class="code">m</span> - for classes that set <span class="code">margin</span></li>
                  <li><span class="code">p</span> - for classes that set <span class="code">padding</span></li>
                </ul>
                <p>Where <span class="font-weight-bold">sides</span> is one of:</p>
                <ul>
                  <li><span class="code">t</span> - for classes that set <span class="cpde">margin-top</span> or <span class="code">padding-top</span></li>
                  <li><span class="code">b</span> - for classes that set <span class="code">margin-bottom</span> or <span class="code">padding-bottom</span></li>
                  <li><span class="code">l</span> - for classes that set <span class="code">margin-left</span> or <span class="code">padding-left</span></li>
                  <li><span class="code">r</span> - for classes that set <span class="code">margin-right</span> or <span class="code">padding-right</span></li>
                  <li><span class="code">x</span> - for classes that set both <span class="code">*-left</span> and <span class="code">*-right</span></li>
                  <li><span class="code">y</span> - for classes that set both <span class="code">*-top</span> and <span class="code">*-bottom</span></li>
                  <li>blank - for classes that set a <span class="code">margin</span> or <span class="code">padding</span> on all 4 sides of the element</li>
                </ul>
                <p>Where <span class="font-weight-bold">size</span> is one of:</p>
                <ul>
                  <li><span class="code">0</span> - for classes that eliminate the span,<code>margin</code> or <span class="code">padding</span> by setting it to <span class="code">0</span></li>
                  <li><span class="code">1</span> - (by default) for classes that set the <span class="code">margin</span> or <span class="code">padding</span> to <span class="code">$spacer * .25</span></li>
                  <li><span class="code">2</span> - (by default) for classes that set the <span class="code">margin</span> or <span class="code">padding</span> to <span class="code">$spacer * .5</span></li>
                  <li><span class="code">3</span> - (by default) for classes that set the <span class="code">margin</span> or <span class="code">padding</span> to <span class="code">$spacer</span></li>
                  <li><span class="code">4</span> - (by default) for classes that set the <span class="code">margin</span> or <span class="code">padding</span> to <span class="code">$spacer * 1.5</span></li>
                  <li><span class="code">5</span> - (by default) for classes that set the <span class="code">margin</span> or <span class="code">padding</span> to <span class="code">$spacer * 3</span></li>
                  <li><span class="code">auto</span> - for classes that set the <span class="code">margin</span> to auto</li>
                </ul>
              </div>
            </div>

           <!--  <div class="row mt-4">
              <div class="col">
                <p class="h5">Horizontal centering</p>
                <p>Additionally, Bootstrap also includes an <span class="code">.mx-auto</span> class for horizontally centering fixed-width block level content—that is, content that has <span class="code">display: block</span> and a <span class="code">width</span> set—by setting the horizontal margins to <span class="code">auto</span>.</p>
              </div>
            </div>   -->          
          </div>
        </div>
        <!-- Content End -->
      </div>
    </div>  
  </div>
  <!-- eslint-enable -->
</template>

<script>
export default {
  name: "Spacing"
};
</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/Spacing.vue